import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "onboarding-step" }
const _hoisted_2 = { class: "ai-section" }
const _hoisted_3 = { class: "ai-input-group" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "manual-section" }
const _hoisted_6 = { class: "form-group" }

import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { aiAPI, APIError } from '@/api'
import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

interface StepData {
  businessUrl: string
  aboutBusiness: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingStep1',
  props: {
    initialData: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = useStore()
const localData = ref<StepData>({ ...props.initialData })
const isAnalyzing = ref(false)

watch(localData, (newData) => {
  emit('update', { ...newData })
}, { deep: true })

const analyzeWithAI = async () => {
  if (!localData.value.businessUrl || isAnalyzing.value) return

  isAnalyzing.value = true
  try {
    const result = await aiAPI.analyzeBusinessUrl(localData.value.businessUrl)
    if (result.business_description) {
      localData.value.aboutBusiness = result.business_description
    }
  } catch (error) {
    const errorMessage = error instanceof APIError ? error.message : 'An unexpected error occurred'
    store.commit('SET_ERROR', errorMessage)
  } finally {
    isAnalyzing.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "step-title" }, "Tell us about your business", -1)),
    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "step-description" }, " This helps us understand your brand and create content that matches your voice. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"ai-section-header\" data-v-c5c8cefc><div class=\"ai-icon\" data-v-c5c8cefc><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" data-v-c5c8cefc><path d=\"M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z\" data-v-c5c8cefc></path></svg></div><div class=\"ai-section-text\" data-v-c5c8cefc><h3 class=\"ai-section-title\" data-v-c5c8cefc>Auto-fill with AI</h3><p class=\"ai-section-subtitle\" data-v-c5c8cefc>Enter your website URL and we&#39;ll analyze it automatically</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localData.value.businessUrl) = $event)),
          type: "url",
          class: "ai-input",
          placeholder: "https://yourbusiness.com",
          onKeydown: _withKeys(analyzeWithAI, ["enter"])
        }, null, 544), [
          [_vModelText, localData.value.businessUrl]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary ai-analyze-btn",
          disabled: !localData.value.businessUrl || isAnalyzing.value,
          onClick: analyzeWithAI
        }, [
          (isAnalyzing.value)
            ? (_openBlock(), _createBlock(LoadingSpinner, {
                key: 0,
                size: "sm"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[2] || (_cache[2] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 20 20",
                  fill: "currentColor",
                  class: "btn-icon"
                }, [
                  _createElementVNode("path", { d: "M7.156 2.344a.75.75 0 01.594.75v.312c0 1.25.455 2.435 1.28 3.356l.13.15a.75.75 0 01-1.12.992l-.13-.15a6.257 6.257 0 01-1.66-4.348V3.094a.75.75 0 01.906-.75zm5.688 0a.75.75 0 01.906.75v.312a6.257 6.257 0 01-1.66 4.348l-.13.15a.75.75 0 01-1.12-.992l.13-.15a4.757 4.757 0 001.28-3.356V3.094a.75.75 0 01.594-.75zM10 6.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 1.5a2 2 0 110 4 2 2 0 010-4zm-7.5 4a.75.75 0 01.75-.75h.312a4.757 4.757 0 003.356-1.28l.15-.13a.75.75 0 01.992 1.12l-.15.13a6.257 6.257 0 01-4.348 1.66H3.25a.75.75 0 01-.75-.906zm14.156.156a.75.75 0 01.75.75v.312a.75.75 0 01-.75.75h-.312a6.257 6.257 0 01-4.348-1.66l-.15-.13a.75.75 0 01.992-1.12l.15.13a4.757 4.757 0 003.356 1.28h.312a.75.75 0 01.75.438z" })
                ], -1)),
                _cache[3] || (_cache[3] = _createTextVNode(" Analyze ", -1))
              ], 64))
        ], 8, _hoisted_4)
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "divider" }, [
      _createElementVNode("span", { class: "divider-text" }, "or fill in manually")
    ], -1)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label" }, "About your business", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localData.value.aboutBusiness) = $event)),
          class: "form-textarea",
          rows: "5",
          placeholder: "Describe what your business does, your target audience, and unique value proposition..."
        }, null, 512), [
          [_vModelText, localData.value.aboutBusiness]
        ])
      ])
    ])
  ]))
}
}

})